export const EventNames = {
  HYP_JOB_SEARCH: 'HYP: search a job - job view',
  HYP_JOB_CLICK: 'HYP: select a job - job view',
  HYP_SUMMARY_TASK_VIEW: 'HYP: summary bar - click - task view',
  HYP_SUMMARY_JOB_VIEW: 'HYP: summary bar - click - job view',
  HYP_ABORT_BTN_CLICK: 'HYP: abort a job - job view',
  HYP_JOB_LIST_DASHBOARD_PAGE: 'HYP: Job List Dashboard',
  HYP_FILTER_JOB_LIST_DASHBOARD: 'HYP: filter jobs - job view',
  HYP_COPY_ACCESS_KEY: 'HYP: copy credentials',
  HYP_GROUP_OR_TASK_CLICK: 'HYP: select a task - task view',
  HYP_DISCOVERY_TAB_CLICK: 'HYP Group discovery clicks',
  HYP_STAGE_TAB_CLICK: 'HYP: select logs tab - task view',
  HYP_POST_TAB_CLICK: 'HYP Group poststeps clicks',
  HYP_DATA_SPLIT_TAB_CLICK: 'HYP Group data split clicks',
  HYP_ARTIFACT_TAB_CLICK: 'HYP Group artifacts clicks',
  HYP_DISCOVERY_LOG_CLICK: 'HYP Group discovery logs clicks',
  HYP_DISCOVERY_LOG_SEARCH: 'HYP Group discovery logs search clicks',
  HYP_PRESTEP_LOG_CLICK: 'HYP: expand a pre step - task view',
  HYP_PRESETP_LOG_SEARCH: 'HYP: search in pre step - task view',
  HYP_PRESETP_LOG_DOWNLOAD: 'HYP: download pre step logs - task view',
  HYP_STAGE_LOG_CLICK: 'HYP: expand a scenario - task view',
  HYP_ASSOCIATED_LINK_CLICK: 'HYP: view test - scenarios - task view',
  HYP_STAGE_LOG_SEARCH: 'HYP: search in scenarios - task view',
  HYP_STAGE_LOG_DOWNLOAD: 'HYP: download scenario logs - task view',
  HYP_POSTSTEP_LOG_CLICK: 'HYP: expand a post step - task view',
  HYP_POSTSTEP_LOG_SEARCH: 'HYP: search in post step - task view',
  HYP_POSTSTEP_LOG_DOWNLOAD: 'HYP: download post step logs - task view',
  HYP_ARTIFACT_LOG_CLICK: 'HYP Group artifect logs clicks',
  HYP_ARTIFACT_LOG_SEARCH: 'HYP Group artifact search clicks',
  HYP_DATA_SPLIT_LOG_CLICK: 'HYP Group poststeps logs clicks',
  HYP_DATA_SPLIT_LOG_SEARCH: 'HYP Group poststeps search clicks',
  HYP_DOCUMENTAION_LINK_CLICK: 'HYP: view docs',
  HYP_ONBOARDING_SUPPORT_CHAT_CLICK: 'HYP_onboarding_talk',
  HYP_ONBOARDING_SUPPORT_CHAT_CLICK_SAMPLE_PAGE: 'HYP_sample_talk',
  HYP_ONBOARDING_SUPPORT_CHAT_CLICK_YAML_PAGE: 'HYP_yaml_talk',
  HYP_ONBOARDING_COPY_EXECUTE_CMD_YAML_PAGE:
    'HYP: copy execute command - generate yaml',
  HYP_ONBOARDING_VIEW_DOC_CLICK: 'HYP: view docs - quickstart',
  HYP_ONBOARDING_VIEW_DOC_CLICK_SAMPLE_PAGE: 'HYP: view docs - try an example',
  HYP_ONBOARDING_VIEW_DOC_CLICK_YAML_PAGE: 'HYP: view docs - generate yaml',
  HYP_ONBOARDING_TRY_SAMPLE: 'HYP: tab change - quickstart page',
  HYP_ONBOARDING_TRY_SAMPLE_YAML: 'HYP_onboarding_sample_yaml',
  HYP_ONBOARDING_LANGUAGE_SELECTION: 'HYP: language selected - quickstart page',
  HYP_ONBOARDING_FRAMEWORK_SELECTION:
    'HYP: framework selected - quickstart page',
  HYP_ONBOARDING_GET_STARTED_CLICK: 'HYP: get started - quickstart page',
  HYP_ONBOARDING_REDIRECT_SUCCESS_SAMPLE_PAGE:
    'HYP: view test results - try an example',
  HYP_ONBOARDING_REDIRECT_FAILURE_SAMPLE_PAGE:
    'HYP_onboarding_view_results_sample_failure',
  HYP_ONBOARDING_REDIRECT_SUCCESS_YAML_PAGE:
    'HYP: view test results - generate yaml',
  HYP_ONBOARDING_REDIRECT_FAILURE_YAML_PAGE:
    'HYP: view test results - generate yaml',
  HYP_ONBOARDING_REDIRECT_SUCCESS_AUTO_YAML_PAGE:
    'HYP_onboarding_redirect_success_yaml',
  HYP_ONBOARDING_REDIRECT_SUCCESS_AUTO_SAMPLE_PAGE:
    'HYP_onboarding_redirect_success_sample',
  HYP_ONBOARDING_AUTOMATIC_REDIRECT_SUCCESS: 'HYP_onboarding_redirect_success',
  HYP_ONBOARDING_OS_SELECTION_SAMPLE: 'HYP_onboarding_os_selection_sample',
  HYP_ONBOARDING_OS_SELECTION_YAML: 'HYP: os selection - generate yaml',
  HYP_ONBOARDING_DOWNLOAD_REPO_SAMPLE:
    'HYP: download sample project - try an example',
  HYP_ONBOARDING_GIT_CLONE_SAMPLE: 'HYP: copy clone command - try an example',
  HYP_ONBOARDING_HYPEREXECUTE_CLI_DOWNLOAD_SAMPLE:
    'HYP: download hypex cli - try an example',
  HYP_ONBOARDING_HYPEREXECUTE_CLI_DOWNLOAD_YAML:
    'HYP: download cli - generate yaml',
  HYP_ONBOARDING_COPY_EXECUTE_CMD_SAMPLE:
    'HYP: copy execute command - try an example',
  HYP_ONBOARDING_COPY_EXECUTE_CMD_YAML: 'HYP_onboarding_download_yaml',
  HYP_ONBOARDING_DOWNLOAD_YAML_CODE_YAML:
    'HYP: download yaml file - generate yaml',
  HYP_ONBOARDING_COPY_YAML_CODE_YAML: 'HYP: get yaml file - generate yaml',
  HYP_ONBOARDING_COPY_YAML_CODE_SAMPLE: 'HYP: get yaml file - try an example',
  HYP_ONBOARDING_RESET_YAML_CODE_YAML: 'HYP: reset yaml file - generate yaml',
  HYP_ONBOARDING_UPGRADE_NOW_TRIAL: 'HYP: click cta - trial info',
  HYP_ONBOARDING_CONTACTSALES_TRIAL: 'HYP_trialinfo_contactsales',
  HYP_ONBOARDING_UPGRADE_NOW_LIMIT_TEN: 'HYP_limit10_upgrade',
  HYP_ONBOARDING_CONTACTSALES_LIMIT_TEN: 'HYP_limit10_contactsales',
  HYP_ONBOARDING_UPGRADE_NOW_LIMIT_SIXTY: 'HYP_limit60_upgrade',
  HYP_ONBOARDING_CONTACTSALES_LIMIT_SIXTY: 'HYP_limit60_contactsales',
  HYP_ONBOARDING_UPGRADE_NOW_LIMIT_NINTY: 'HYP_limit90_upgrade',
  HYP_ONBOARDING_CONTACTSALES_LIMIT_NINTY: 'HYP_limit90_contactsales',
  HYP_ONBOARDING_UPGRADE_NOW_LIMIT_POPUP: 'HYP_limit_upgrade',
  HYP_ONBOARDING_CONTACTSALES_LIMIT_POPUP: 'HYP_limit_contactsales',
  HYP_ONBOARDING_TRIAL_INFO_CLICKED: 'HYP: click trial info',
  HYP_ONBOARDING_RENEW_PLAN_EXPIRE: 'HYP_planexpire_renew',
  HYP_ONBOARDING_CONTACTSALES_PLAN_EXPIRE: 'HYP_planexpire_contactsales',
  HYP_ONBOARDING_RENEW_PLAN_EXPIRE_NINTY: 'HYP_plan90expire_renew',
  HYP_ONBOARDING_CONTACTSALES_PLAN_EXPIRE_NINTY:
    'HYP_plan90expire_contactsales',
  HYP_ONBOARDING_RENEW_PLAN_EXPIRE_TRIAL: 'HYP_trialexpire_renew',
  HYP_ONBOARDING_CONTACTSALES_PLAN_EXPIRE_TRIAL: 'HYP_trialexpire_contactsales',
  HYP_ONBOARDING_HOME_PAGE: 'HYP: quickstart page',
  HYP_HELP_GITPOD: 'HYP: run test on gitpod - help section',
  HYP_GITPOD_GITHUB: 'HYP_gitpod_github',
  HYP_HELP_QUICKSTART: 'HYP: get help - help section',
  HYP_HELP_DOC: 'HYP_doc_help',
  HYP_HELP_GITHUB_SAMPLE: 'HYP_githubsamples_help',
  HYP_HELP_SUPPORT: 'HYP_support_help',
  HYP_REPORT_DOWNLOAD: 'HYP: download a report - task view',
  HYP_DOWNLOAD_ARTEFACT: 'HYP: download an artifact - task view',
  HYP_DELETE_ARTEFACT: 'HYP: delete an artifact - task view',
  HYP_TASK_FILTER: 'HYP: filter tasks  - task view',
  HYP_SECRET_CLICK: 'HYP: click secrets',
  HYP_SECRET_ADD_CLICK: 'HYP: add a secret',
  HYP_SECRETS_ADD: 'HYP: added a secret',
  HYP_SECRETS_ACTION: 'HYP: select a secret action',
  HYP_SECRETS_EDIT: 'HYP: edited a secret',
  HYP_SECRETS_DELETE: 'HYP_secrets_delete',
  HYP_ONBOARDING_TRY_NOW: 'HYP: click cta - try now page',
  HYP_TRY_NOW_PAGE: 'HYP: view try now page',
  HYP_ONBOARDING_BOOK_DEMO: 'HYP Intermediary book',
  HYP_STAGE_LOGS_DOWNLOAD: 'HYP logs download',
  HYP_STAGE_FULL_SCREEN: 'HYP: toggle logs view - task view',
  HYP_STAGE_EXIT_SCREEN: 'HYP logs exit full screen',
  EVENT_SCREENSHOT_SEARCH: 'HYP Screenshot Search',
  HYP_ONBOARDING_VIEW_IN_GITHUB: 'HYP: view in github - try an example',
  HYP_ONBOARDING_VIEW_DOC_VIEW_TEST_RESULT:
    'HYP: view docs - view test results - try an example',
  HYP_ONBOARDING_VIEW_DOC_VIEW_TEST_RESULT_YAML:
    'HYP: view docs - view test results - generate yaml',
  HYP_ONBOARDING_SKIP_STEPS_SAMPLE: 'HYP: skip step - try an example',
  HYP_ONBOARDING_SKIP_STEPS_YAML: 'HYP: skip step - generate yaml',
  HYP_ONBOARDING_HYPEREXECUTE_UPDATE_CONCURENCY_YAML:
    'HYP: update concurrency - generate yaml',
  HYP_ONBOARDING_HYPEREXECUTE_UPDATE_RETRY_AND_TIMEOUT_YAML:
    'HYP: set retry and timeout - generate yaml',
  HYP_ONBOARDING_HYPEREXECUTE_UPDATE_DISCOVERY_YAML:
    'HYP: set test discovery path - generate yaml',
  HYP_ONBOARDING_HYPEREXECUTE_UPDATE_TEST_RUNNER_YAML:
    'HYP: set test runner command - generate yaml',
  HYP_ONBOARDING_HYPEREXECUTE_AUTOSPLIT_STRATIGY_CLICK:
    'HYP: auto splitting help - generate yaml',
  HYP_EVENT_APPROVE_TEST: 'HYP: vr test approved',
  HYP_EVENT_REPORT_BUG: 'HYP: vr report bug',
  HYP_EVENT_COMPARISON_SWITCH: 'HYP: vr comparison switch',
  HYP_ARTIFACT_BTN_CLICK: 'HYP: click artifacts - task view',
  HYP_JOB_LABEL_SEARCH: 'HYP: search label - filter jobs - job view',
  HYP_TOP_BANNER_CLOSE_BUTTON: 'HYP: close top banner',
  HYP_CLICK_OKAY_BUTTON_POPUP: 'HYP: clicked okay in popup - generate yaml',
  HYP_ONBOARDING_TRIGGER_TEST_BUTTON_CLICK: 'HYP: trigger test - quick run',
  HYP_ONBOARDING_DASHBOARD_BUTTON_CLICK: 'HYP: go to dashboard - quick run',
  HYP_NEGATIVE_TASK_TIME: 'HYP: negative task time',
  HYP_CONTINUE_TESTING_MODAL: 'HYP: continue testing - modal',
  HYP_CONTINUE_TOUR_MODAL: 'HYP: continue tour - modal',
  HYP_SELECT_A_CTA_MODAL: 'HYP: select a cta - modal',
  HYP_SKIP_FOR_NOW_MODAL: 'HYP: skip for now - modal',
  HYP_TALK_TO_EXPERT_MODAL: 'HYP: talk to expert - modal',
  HYP_ONBOARDING_VIEW_DOC_QUICK_RUN_PAGE: 'HYP: view docs - quick run',
  HYP_ONBOARDING_CLICK_DOC_LINK: 'HYP: click doc hyperlink - quick run',
  HYP_ONBOARDING_SKIP_LINK_QUICK_RUN: 'HYP: skip configure yaml - quick run',
  HYP_ONBOARDING_QUICK_RUN_JOB_INVOKED:
    'HYP: job invoked successfully - quick run',
  HYP_ONBOARDING_CUSTOMER_SUPPORT_QUICK_RUN:
    'HYP: click support hyperlink - invoke error - quick run',
  HYP_ONBOARDING_WAIT_ERROR_QUICK_RUN:
    'HYP: viewed invoke error message - quick run',
  HYP_TRY_NOW_MODAL_CTA: 'HYP: click cta - try now modal',
  HYP_TRY_NOW_MODAL_CLOSE: 'HYP: closed modal - try now modal',
  HYP_QUICK_RUN_UPDATE_YAML: 'HYP: update yaml parameters - quick run',
};
